import { useParams, useLocation } from 'react-router';
import { useApiRead } from 'api-read-hook';
import { Api } from '../../api';
import { ScreenError, SoloLoading } from '../../components';
import ChatDetailLoaded from './ChatDetailLoaded';
import { Model } from '../../models';
import type { HydraCollection } from '../../types';

export default function ChatBroadcastDetail() {
  const { userId, teamId } = useParams();
  const location = useLocation();

  const isTeamBroadcast = location.pathname.includes('/broadcast/team/');
  const entityId = isTeamBroadcast ? teamId : userId;

  const broadcastApi = Api.ChatConversation.useReadCollectionClinicianbroadcast(
    {
      staleWhileInvalidated: true,
    },
  );

  const chat = Model.Chat.findBroadcastChat(
    broadcastApi.data?.member,
    entityId,
    isTeamBroadcast,
  );

  const conversationId = chat?.conversation?.id;

  const messagesApi = useApiRead<
    HydraCollection<Api.ChatMessage.V_ChatConversationSub>
  >(conversationId ? `/chat-conversations/${conversationId}/messages` : null, {
    staleWhileInvalidated: true,
  });

  if (broadcastApi.error) return <ScreenError {...broadcastApi} />;
  if (messagesApi.error) return <ScreenError {...messagesApi} />;

  if (!broadcastApi.data) {
    return <SoloLoading />;
  }

  const targetUser = chat?.user || null;
  const teamWithMembers = chat?.team
    ? {
        ...chat.team,
        teamMembers: chat.teamMembers || [],
      }
    : null;

  return (
    <ChatDetailLoaded
      messagesApi={messagesApi}
      chatsApi={broadcastApi}
      user={targetUser}
      team={teamWithMembers}
      chatType="broadcast"
      userId={isTeamBroadcast ? undefined : entityId}
      teamId={isTeamBroadcast ? entityId : undefined}
      entityType={isTeamBroadcast ? 'team' : 'user'}
    />
  );
}
